module.exports = __webpack_public_path__ + "img/ian-giribaldi.84dc0f88.jpg";